import isAlpha from "validator/es/lib/isAlpha";
import isEmail from "validator/es/lib/isEmail";

export class Validate {
  public valiedSpecialChar = "-,./_()#~:;&<>@ "; // 입력 가능한 특수문자
  public isEmail = isEmail;
  /**
   * @true 한국어
   * @false 한국어 외 모두
   */
  public isOnlyKor = (value: string) => {
    const kor = /^[가-힣]*$/;
    return kor.test(value);
  };
  /**
   * @true 영문
   * @false 영문 외 모두
   */
  public isOnlyEng = (value: string) => {
    return /^[a-zA-Z ]*$/.test(value);
  };
  /**
   * @true 영문 대문자
   * @false 영문 대문자 외 모두
   */
  public isOnlyUpperEng = (value: string) => {
    return /^[A-Z]*$/.test(value);
  };
  /**
   * @true 숫자
   * @false 숫자 외 모두
   */
  public isOnlyNumber = (value: string | number) => {
    return /^[0-9]*$/.test(value.toString());
  };
  /**
   * @true 영문, 숫자, 입력가능한 특수문자
   * @false 영문, 숫자, 입력가능한 특수문자 외 모두
   */
  public isEngInput = (value: string) => {
    const reg = new RegExp(`^[0-9a-zA-Z${this.valiedSpecialChar}]*$`);
    return reg.test(value);
  };
}
